import { PaymentMethod } from 'app/constants/delegation/paymentMetod'

export const getPaymentMethodName = (
  paymentMethod: PaymentMethod,
  translate: (string) => string,
): string => {
  const text: string = PaymentMethod[paymentMethod]
  return translate(`paymentMethod.${text}`)
}
